import { render, staticRenderFns } from "./NodeOnboardingAddSectionButton.vue?vue&type=template&id=00c09441&"
import script from "./NodeOnboardingAddSectionButton.vue?vue&type=script&lang=ts&"
export * from "./NodeOnboardingAddSectionButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports